import { useDispatch, useSelector } from 'react-redux'

import actions from 'actions/auth'
import { menuLoadBoxPrices } from 'actions/menu'
import { useIsOptimizelyFeatureEnabled } from 'containers/OptimizelyRollouts'
import { getPricePerServing } from 'routes/BoxPrices/boxPricesSelectors'
import { useBasket } from 'routes/Menu/domains/basket'
import menuFetchData from 'routes/Menu/fetchData'

/**
 * Experiments running on home page that controls order or visibility
 * of homepage sections should be placed here
 */
export const useGetHomePageExperiments = () => {
  const isHowGoustoWorksEnabled = useIsOptimizelyFeatureEnabled(
    'beetroots_how_gousto_works_web_enabled',
  )
  const isImmersiveHeroEnabled = useIsOptimizelyFeatureEnabled(
    'beetroots_homepage_immersive_hero_web_enabled',
  )

  const isBrandEndorsementsEnabled = useIsOptimizelyFeatureEnabled(
    'beetroots_brand_endorsements_enabled_v2',
  )

  /**
   * Save And Savour is not an experiment but the team decided to put it behind a feature flag because
   * of the versatility of this section. We have a ticket to clean this up in 6 months time
   * https://gousto.atlassian.net/browse/TG-7436
   */
  const isSaveAndSavourEnabled = useIsOptimizelyFeatureEnabled(
    'beetroots_save_and_savour_homepage_section_enabled',
  )

  return {
    isHowGoustoWorksEnabled,
    isImmersiveHeroEnabled,
    isSaveAndSavourEnabled,
    isBrandEndorsementsEnabled,
  }
}

export const useGetPricePerServing = () => useSelector(getPricePerServing)

export const useGetMenuData = () => {
  const dispatch = useDispatch()
  const pricePerServing = useGetPricePerServing()
  const { addRecipe } = useBasket()
  const dispatchRedirectLoggedInUser = () => dispatch(actions.redirectLoggedInUser)
  const dispatchMenuFetchData = () =>
    dispatch(menuFetchData({ query: {}, params: {} }, false, true, { addRecipe }))
  const dispatchMenuLoadBoxPrices = () => dispatch(menuLoadBoxPrices())

  return {
    dispatchRedirectLoggedInUser,
    dispatchMenuFetchData,
    dispatchMenuLoadBoxPrices,
    pricePerServing,
  }
}
